// import React, { useState } from "react";
// import axios from "axios";
// import { useHistory, useParams } from "react-router-dom";
// import TextAreaInput from "../../../UI/Input/TextAreaInput";
// import { Card } from "@mui/material";
// import { endpoints } from "../../../../services/apiurl";
// import Input from "../../../UI/Input/Input";
// import PageTitle from "../../../UI/PageTitle";
// import LoadingButton from "@mui/lab/LoadingButton";
// import SaveIcon from "@mui/icons-material/Save";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// const AddRestCategory = () => {
//   let history = useHistory();
//   let { restro_id } = useParams();
//   var rest_id = localStorage.getItem("restro_id");
//   console.log(rest_id);

//   const [cat, setCat] = useState({
//     name: "",
//     description: "",
//     status: "",
//   });
//   // eslint-disable-next-line no-unused-vars
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [loading, setloading] = useState(false);

//   const { name, status, description } = cat;
//   const onInputChange = (e) => {
//     setCat({ ...cat, [e.target.name]: e.target.value });
//     // console.log(cat);
//   };

//   const onSubmit = async (e) => {
//     setloading(true);
//     e.preventDefault();
//     // if (!selectedFile) {
//     //     alert('Please select image');
//     //     return false;
//     // }
//     const formData = new FormData();
//     formData.append("name", name);
//     formData.append("description", description);
//     formData.append("restro_id", restro_id);
//     formData.append("rest_id", rest_id);

//     formData.append("icon", selectedFile);
//     formData.append("status", status);
//     // console.log('ca', formData);

//     try {
//       const response = await axios.post(endpoints.addCategory, formData);
//       setloading(false);
//       history.goBack();
//       if (response.data && response.data.status === true) {
//         toast.success("Category Added Successfully!", {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       } else {
//         // Handle other cases if needed
//       }
//     } catch (error) {
//       console.error("Error during editing Category:", error);
//       setloading(false);

//       toast.error("Error during editing Category. Please try again.", {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "colored",
//       });
//     }
//   };

//   return (
//     <div className="ui main">
//       <PageTitle title="Add Categorys" linkurl="" linkTitle="" />

//       <Card className="px-3 py-3">
//         <form
//           className="ui form"
//           onSubmit={(e) => onSubmit(e)}
//           encType="multipart/form-data"
//         >
//           <div className="row">
//             <Input
//               id="name"
//               label="Name"
//               type="text"
//               name="name"
//               place="Name"
//               onChange={(e) => onInputChange(e)}
//               requiredInput="required"
//               value={name}
//               class="col col-6"
//             />

//             <div className="col col-6">
//               <label>Status</label>
//               <select
//                 name="status"
//                 required
//                 className="form-control"
//                 onChange={(e) => onInputChange(e)}
//               >
//                 <option value="">Select Status</option>
//                 <option value="2">InActive</option>
//                 <option value="1">Active</option>
//               </select>
//             </div>
//           </div>

//           <div className="row">
//             <TextAreaInput
//               id="description"
//               label="Description"
//               name="description"
//               place="Description"
//               onChange={(e) => onInputChange(e)}
//               requiredInput="required"
//               value={description}
//               class="col col-6"
//             />
//           </div>

//           <div className="row">
//             <div className="col col-6">
//               <div className="mt-3">
//                 <LoadingButton
//                   type="submit"
//                   loading={loading}
//                   loadingPosition="start"
//                   startIcon={<SaveIcon />}
//                   variant="contained"
//                   size="large"
//                 >
//                   Save
//                 </LoadingButton>
//                 <ToastContainer />
//               </div>
//             </div>
//           </div>
//         </form>
//       </Card>
//     </div>
//   );
// };

// export default AddRestCategory;
import React, { useState } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import TextAreaInput from "../../../UI/Input/TextAreaInput";
import { Card } from "@mui/material";
import { endpoints } from "../../../../services/apiurl";
import Input from "../../../UI/Input/Input";
import PageTitle from "../../../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
const AddRestCategory = () => {
  let history = useHistory();
  let { restro_id } = useParams();
  var rest_id = localStorage.getItem("restro_id");

  const [cat, setCat] = useState({
    name: "",
    description: "",
    status: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setloading] = useState(false);

  const { name, status, description } = cat;

  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setCat((prevCat) => ({
      ...prevCat,
      name: "",
      description: "",
    }));
    setSelectedFile(null);
  };
  

  const onSubmit = async (e, isContinue) => {
    e.preventDefault();
    setloading(true);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("restro_id", restro_id);
    formData.append("rest_id", rest_id);
    formData.append("icon", selectedFile);
    formData.append("status", status);

    try {
      const response = await axios.post(endpoints.addCategory, formData);
      setloading(false);

      if (response.data && response.data.status === true) {
        toast.success("Category Added Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        if (isContinue) {
          resetForm(); // Clear the form for new entry
        } else {
          history.goBack(); 
        }
      } else {
        // Handle error case
      }
    } catch (error) {
      setloading(false);
      toast.error("Error during editing Category. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  return (
    <div className="ui main">
      <PageTitle title="Add Category" linkurl="" linkTitle="" />

      <Card className="px-3 py-3">
        <form className="ui form" encType="multipart/form-data">
          <div className="row">
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={name}
              class="col col-6"
            />

            <div className="col col-6">
              <label>Status</label>
              <select
                name="status"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
          </div>

          <div className="row">
            <TextAreaInput
              id="description"
              label="Description"
              name="description"
              place="Description"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={description}
              class="col col-6"
            />
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="button"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                  onClick={(e) => onSubmit(e, false)} // Save button
                >
                  Save
                </LoadingButton>

                {/* <LoadingButton
                  type="button"
                  loading={loading}
                  loadingPosition="start"
                  color="primary"
      endIcon={<ArrowForwardIcon />}
                  variant="contained"
                  size="large"
                  className="ml-2"
                  onClick={(e) => onSubmit(e, true)}
                >
                  Save and Continue
                </LoadingButton> */}

                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddRestCategory;
